import React from 'react'

export const CotizacionCartaComanda = React.forwardRef((props, ref) => {
  const { getQuote } = props

  return (
    <div ref={ref} style={{ textAlign: 'center', marginLeft: '2rem', marginRight: '2rem' }} className='ticket-modal-quotation' >
      {
        getQuote.quote_invoice.fel_hondura ? (
          <div style={{ textAlign: 'left' }}>
            <p style={{ fontWeight: 'bolder' }}>{`Empresa: ${getQuote?.company ? getQuote.company : getQuote?.store?.company?.name}`}</p>
            <p style={{ fontWeight: 'bolder' }}>{`Direccion: ${getQuote?.store?.company?.address}`}</p>
            <p style={{ fontWeight: 'bolder' }}>{`RTN: ${getQuote?.quote_invoice?.fel_hondura?.rtn}`}</p>
            <p style={{ fontWeight: 'bolder' }}>{`Tienda: ${getQuote?.store?.name ? getQuote?.store?.name : getQuote?.store?.name}`}</p>
          </div>
        ) : (
          <div style={{ textAlign: 'left' }}>
            <p style={{ fontWeight: 'bolder' }}>{`Empresa: ${getQuote?.company ? getQuote.company : getQuote?.store?.company?.name}`}</p>
            <p style={{ fontWeight: 'bolder' }}>{`Direccion: ${getQuote?.store?.company?.address}`}</p>
            <p style={{ fontWeight: 'bolder' }}>{`Nit: ${getQuote?.nit ? getQuote.nit : getQuote?.store?.company?.nit}`}</p>
            <p style={{ fontWeight: 'bolder' }}>{`Tienda: ${getQuote?.store?.name ? getQuote?.store?.name : getQuote?.store?.name}`}</p>
            <br></br>
          </div>
        )
      }

      <br></br>
      <p>{`COTIZACIÒN`}</p>
      <div style={{ textAlign: 'left', display: 'flex', justifyContent: 'space-between' }}>
        <div>
          <p style={{ fontWeight: 'bolder' }}>{`Cotización No.:`}</p>
          <p style={{ fontWeight: 'bolder' }}>{`Fecha:`}</p>
          <p style={{ fontWeight: 'bolder' }}>{`Cliente:`}</p>
          <p style={{ fontWeight: 'bolder' }}>{`Nit:`}</p>
          <p style={{ fontWeight: 'bolder' }}>{`Condición:`}</p>
        </div>
        <div>
          <p>{`${getQuote?.id}`}</p>
          <p>{`${getQuote?.date}`}</p>
          <p>{`${getQuote?.client?.name}`}</p>
          <p>{`${getQuote?.client?.nit}`}</p>
          <p>{``}</p>
        </div>
        <div>
          <br></br>
          <p style={{ fontWeight: 'bolder' }}>{`Vence: ${getQuote?.expiration_date}`}</p>
        </div>
        <div style={{ textAlign: 'right' }}>
          {/* <h1>{`Imagen`}</h1> */}
        </div>
      </div>
      <table className='ticket-modal-quotation' style={{ width: '-webkit-fill-available' }}>
        <thead style={{ borderBottom: '2px solid rgba(0, 0, 0, 0.65)', borderTop: '2px solid rgba(0, 0, 0, 0.65)' }}>
          <tr>
            <th>{`Código`}</th>
            <th>{`Producto`}</th>
            <th>{`Cantidad`}</th>
          </tr>
        </thead>
        <tbody>
          {getQuote?.quote_details && getQuote?.quote_details?.map((data) => (
            <tr key={data.id}>
              <td>{`${data.presentation_id}`}</td>
              <td style={{ display: 'flex', textTransform: 'none' }}>{data?.presentation?.description.substring(0, 40)}</td>
              <td>{`${data.quantity}`}</td>
            </tr>
          ))}
        </tbody>
        <div style={{ position: 'fixed', left: '5%', bottom: 0, width: '90%' }}>
        </div>
      </table>
    </div >
  );
});
